import React from 'react';
import { Link } from 'react-router-dom';
import { Image } from 'lucide-react';
import DonationButton from './DonationButton';
import { TbArrowsMinimize } from "react-icons/tb";
import { HiOutlineDocumentRemove } from "react-icons/hi";
import { VscCombine } from "react-icons/vsc";

import heroImage from '../assets/images/llama-2.png';
import { IoGlasses } from "react-icons/io5";

function Home() {
  const tools = [
    { icon: <Image size={40} />, title: 'Images to PDF', path: '/pdf-tools/convert-images-to-PDF' },
    { icon: <HiOutlineDocumentRemove size={40} />, title: 'Remove pages', path: '/pdf-tools/remove-pages-from-pdf' },
    { icon: <VscCombine size={40} />, title: 'Merge PDFs', path: '/pdf-tools/merge-pdfs' },
    { icon: <TbArrowsMinimize size={40} />, title: 'Compress PDF', path: '/pdf-tools/compress-pdf' }
  ];

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold text-center mb-8">
          <div className="flex items-center gap-2 justify-center">
            <IoGlasses size={50} />
            PDF llama
          </div>
        </h1>
        
        <div className="grid grid-cols-4 gap-4 mb-8">
          {tools.map((tool, index) => (
            <Link
              key={index}
              to={tool.path}
              className="flex flex-col items-center p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow"
            >
              {tool.icon}
              <span className="mt-2 text-sm text-center">{tool.title}</span>
            </Link>
          ))}
        </div>

        <div className="text-center">
          <DonationButton />
        </div>

        <img 
          src={heroImage} 
          alt="PDF llama" 
          className="w-0.6 md:w-1/3 mx-auto mt-32 rounded-lg"
        />

      </div>
    </div>
  );
}

export default Home;
